import React from "react";
import { Select } from "antd";
import { ChevronSvg } from "components/Icon";

const MediSelect = (props) => {
  const handleChange = (value) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <Select
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      // filterSort={(optionA, optionB) =>
      //   (optionA?.label ?? "")
      //     .toLowerCase()
      //     .localeCompare((optionB?.label ?? "").toLowerCase())
      // }
      suffixIcon={<ChevronSvg />}
      onChange={handleChange}
      optionLabelProp="label"
      showSearch
      {...props}
    >
      {props.children}
    </Select>
  );
};

export default MediSelect;
